import React from 'react'
import { ChevronDown, ChevronUp, LucideIcon } from 'lucide-react'
import styled from 'styled-typed'
import { PageActionButton } from '../buttons/pageAddButton'

const SelectedCountBox = styled.div`
    background: ${(props) => props.theme.colors.background};
    color: ${(props) => props.theme.colors.textLight};
    width: 2em;
    height: 2em;
    border-radius: 50%;
    margin-left: 0.5em;
    display: flex;
    align-items: center;
    justify-content: center;
`

interface MenuToggleProps {
    menuName: string | React.ReactNode
    selectedCount?: number
    loading: boolean
    expanded: boolean
    toggleOptionsContainer: () => void
    icon?: LucideIcon
    open?: boolean
    arrowHidden?: boolean
    iconOnly?: boolean
}

export function MenuToggleComponent(props: MenuToggleProps) {
    return (
        <PageActionButton
            onClick={props.toggleOptionsContainer}
            className={props.loading ? 'loading' : props.expanded ? 'expanded' : ''}
            icon={props.icon}
            label={props.iconOnly ? String(props.menuName) : undefined}
            badge={props.selectedCount}
            endIcon={props.arrowHidden ? undefined : props.expanded ? ChevronUp : ChevronDown}
        >
            {props.menuName}
            {!!props.selectedCount && <SelectedCountBox>{props.selectedCount}</SelectedCountBox>}
        </PageActionButton>
    )
}
